/**
 * Badge visuel pour afficher un statut ou une visibilité.
 */

import React from "react";
import "./StatusBadge.css";

/**
 * Affiche un badge coloré selon le type et la valeur.
 * @param {Object} props
 * @param {string} props.value - Valeur du badge (ex: "in_progress", "public").
 * @param {string} props.label - Texte affiché dans le badge.
 * @param {string} [props.variant] - Variante de couleur (success, warning, info, danger).
 */
export default function StatusBadge({ value, label, variant }) {
  const colorClass = variant || getAutoVariant(value);
  return <span className={`badge badge-${colorClass}`}>{label}</span>;
}

/**
 * Détermine la couleur automatiquement selon la valeur.
 * @param {string} value - Valeur du statut.
 * @returns {string} Classe CSS de variante.
 */
function getAutoVariant(value) {
  const mapping = {
    done: "success",
    in_progress: "warning",
    public: "info",
    private: "secondary",
    A: "danger",
    B: "warning",
    C: "secondary",
    "1": "danger",
    "2": "warning",
    "3": "secondary",
  };
  return mapping[value] || "secondary";
}
